/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PreviousDamages } from './previousDamages';

/**
 * Represents a motor vehicle fully comprehensive insurance.   (german: Kfz Vollkasko)   (bipro-kraftfahrt::Fahrzeugvollversicherung)
 */
export interface PreviousFullyComprehensiveInsurance {
  /**
   * Technical discriminator for the concrete elementary product type.
   */
  productType: string;
  damages?: PreviousDamages;
}
